var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "calendar-events" } },
    [
      _c("CalendarEventsToolbox", {
        attrs: {
          "selected-calendar-id": _vm.selectedCalendarId,
          mode: _vm.mode,
          type: _vm.type,
          reservationPlans: _vm.reservationPlans,
        },
        on: {
          changeMode: function (_mode) {
            return (_vm.mode = _mode)
          },
          calendarChange: function (id) {
            return (_vm.selectedCalendarId = id)
          },
        },
      }),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("vc-date-picker", {
              attrs: { color: "red", "is-dark": "" },
              model: {
                value: _vm.selectedDate,
                callback: function ($$v) {
                  _vm.selectedDate = $$v
                },
                expression: "selectedDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "events-wrapper" },
          [
            _vm.events.length
              ? _c("CalendarEventListview", {
                  attrs: {
                    events: _vm.events,
                    "group-by-date": true,
                    calendarList: _vm.calendarList,
                  },
                })
              : _c("NoMessage", { attrs: { desc: "Etkinlik Bulunamadı" } }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }